<template>
    <div>
        <nav class="navbar navbar-light floating bg-white custom-nav pt-2 fixed-top flex-column floating pb-1">
            <div class="container d-flex justify-content-between">
                <div class="d-flex justify-content-start">
                    <div class="d-flex justify-content-start">
                        <div class="d-flex justify-content-between">
                            <button class="navbar-toggler align-self-center p-2" v-on:click="sidebar = true">
                                <span class="line"></span>
                                <span class="line"></span>
                                <span class="line mb-0"></span>
                            </button>

                            <portal-target name="title"></portal-target>
                        </div>
                    </div>

                    <portal-target name="logo" slim>
                        <ul class="nav navbar-nav ml-2">
                            <li class="nav-item d-flex justify-content-center my-auto">
                                <router-link :to="`/${siteSlug || lastSite || ''}`">
                                    <img :src="`/images/site-option/${logo || 0}?width=180&height=72&fit=contain`" alt="logo" class="company-logo">
                                </router-link>
                            </li>
                        </ul>
                    </portal-target>
                </div>

                <div class="d-flex justify-content-start">
                    <a href="/profile" class="d-flex align-items-center profile-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="35" height="35">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                        </svg>
                    </a>
                    <portal-target name="cart" class="d-flex justify-content-end ml-2 pr-0"></portal-target>
                </div>
            </div>

            <div class="container" v-if="variantName">
                <div class="bg-light w-100 px-2 py-2 mt-1">
                    <div class="btn-eatin cursor-pointer text-nowrap">
                        {{ $t("Viewing") }}
                        <strong>{{ variantName }}</strong>
                        {{ $t("menu") }}

                        <span v-if="enabledMenus.length > 1 || enabledMenus.click_and_collect">
                            (
                            <span class="text-success" v-on:click="variantSelectAction"><u>{{ $t("Change") }}</u></span>
                            )
                        </span>
                    </div>

                    <div class="small font-italic text-muted" v-if="cart.variant == 'click-and-collect'">
                        <span v-if="slotFormat === 'start_time'">{{ cart.extra.slot_text || $t('Pick-up time: Unknown')
                        }}</span>
                        <span v-else-if="slotFormat === 'start_time_end_time'">{{ cart.extra.slot_long_format_text ||
                            $t('Pick-up time: Unknown') }}</span>
                    </div>
                </div>
            </div>
        </nav>

        <div class="spacer" :style="`margin-top: ${navbarHeight}px`"></div>

        <router-view></router-view>

        <vue-sidebar :open="sidebar" @change="sidebar = $event">
            <div class="d-flex justify-content-center">
                <router-link :to="`/${siteSlug || ''}`" style="min-width: 99px; min-height: 72px">
                    <img :src="`/images/site-option/${logo || 0}?width=180&height=72&fit=contain`" alt="logo" class="company-logo">
                </router-link>
            </div>

            <ul class="navbar-nav mt-4 mb-4" v-if="!user">
                <li class="nav-item">
                    <button class="btn login-btn-home btn-lg btn-block left-icon-holder" v-on:click="redirectToLogin">
                        <i class="fas fa-sign-in-alt align-middle" aria-hidden="true"></i>
                        {{ $t("Log in to Menu Connect for") }} {{ companyName }}
                    </button>
                </li>
            </ul>

            <ul class="navbar-nav mt-4 mb-4" v-else>
                <li class="nav-item d-flex justify-content-between">
                    <router-link class="link w-100 mr-2" to="/profile">
                        <button class="btn login-btn-home menu-btn-home bg-dark text-light btn-lg btn-block left-icon-holder">
                            <i class="fas fa-user-circle align-middle" aria-hidden="true"></i>
                            {{ $t("My profile") }}
                        </button>
                    </router-link>
                    <router-link class="link w-100 ml-2" to="/my-orders">
                        <button class="btn login-btn-home menu-btn-home bg-dark text-light btn-lg btn-block left-icon-holder">
                            <i class="fas fa-list align-middle" aria-hidden="true"></i>
                            {{ $t("My orders") }}
                        </button>
                    </router-link>
                </li>
            </ul>

            <div class="order-style px-3 py-2 mt-4" v-if="siteSlug && cart && enabledMenus.click_and_collect">
                <template v-if="Object.keys(enabledMenus).length > 1">
                    <p>{{ $t("Change how you order") }}</p>

                    <div class="radio form-check form-check-inline" v-for="(details, key) in variants" :key="key">
                        <input class="form-check-input" name="radio-group" type="radio" :id="`${key}-cb`" :value="key" :checked="key == cart.variant" v-on:change="setVariant(key)">
                        <label class="form-check-label" :for="`${key}-cb`">{{ details.name }}</label>
                    </div>
                </template>

                <div v-if="cart.variant == 'click-and-collect'" class="mt-2 pt-3 border-top">
                    <p>{{ $t("Pickup time") }}</p>

                    <div class="d-flex">
                        <p class="mt-1 mb-0 mr-2 font-italic">{{ cart.extra.slot_text }}</p>
                        <router-link class="btn btn-success btn-sm mt-0 ml-2 px-3" :to="`/${siteSlug}/select-slot`">
                            {{ cart.slot_id ? $t('Change') : $t('Select') }}
                        </router-link>
                    </div>
                </div>
            </div>

            <portal-target name="navbar-list"></portal-target>

            <ul class="navbar-nav mt-4 mb-4" v-if="siteSlug && cart && cart.extra.total_amount > 0">
                <li class="nav-item">
                    <router-link :to="`/${siteSlug}/cart`" class="link">
                        <button class="btn menu-btn-checkout btn-block">
                            {{ $t("Checkout ({items} ITEMS, {price})", {
                                items: cart.extra.number_of_items,
                                price: cartTotalAmountFormatted
                            }) }}
                        </button>
                    </router-link>
                </li>
            </ul>

            <ul class="navbar-nav mt-4 mb-4">
                <li class="mb-2">
                    <div class="form-group">
                        <select v-model="currentLanguage" class="w-100 table-select border bg-white" style="font-size: 14px">
                            <option v-for="(name, code) in availableLanguages" :value="code">{{ name }}</option>
                        </select>
                    </div>
                </li>
            </ul>

            <ul class="navbar-nav mt-4 mb-4">
                <li class="nav-item mb-2" v-if="siteSlug">
                    <router-link :to="`/${siteSlug}/contact`" class="btn menu-btn-home btn-block">
                        {{ $t("Opening hours") }}
                    </router-link>
                </li>

                <li class="nav-item">
                    <button class="btn menu-btn-home btn-block" v-on:click="sidebar = false">{{ $t("Close") }}</button>
                </li>
            </ul>
        </vue-sidebar>

        <variant-select modal-name="variant-select" v-if="Object.keys(enabledMenus).length > 1" :site-slug="siteSlug">
        </variant-select>

        <login-modal />
    </div>
</template>

<script>
import VariantSelect from "../components/modals/VariantSelect";
import LoginModal from "../components/modals/Login.vue";

export default {
    components: { VariantSelect, LoginModal },
    data() {
        return {
            cart: window.app.cart,
            siteSlug: this.$route.params.site,
            logo: window.app.site_logo,
            sidebar: false,
            enabledMenus: window.app.enabled_menus,
            companyName: window.app.company_name,
            user: window.app.user,
            variants: window.app.variants,
            lastSite: window.app.last_site,
            navbarHeight: 0,
            slotFormat: window.app.slot_format,
            currentLanguage: window.default_locale,
            availableLanguages: window.available_locales
        }
    },
    watch: {
        $route() {
            this.$nextTick(() => {
                this.onMounted();
            });
        },
        currentLanguage() {
            this.setLanguage(this.currentLanguage);
        }
    },
    computed: {
        variantName() {
            return this.cart ? this.variants[this.cart.variant].name : null;
        },
        cartTotalAmountFormatted() {
            return this.$options.filters.moneyFormat(this.cart.extra.total_amount);
        }
    },
    methods: {
        setLanguage(language) {
            this.$axios
                .post(`/set-language`, { language: language })
                .then(response => {
                    window.location.reload();
                });
        },
        setVariant(variant) {
            window.location.href = `/${this.siteSlug}/${variant}`;
        },
        redirectToLogin() {
            window.location = '/login';
        },
        variantSelectAction() {
            if (Object.keys(this.enabledMenus).length > 1) {
                this.$modal.show('variant-select');
            } else if (this.enabledMenus.click_and_collect) {
                this.$router.push(`/${this.siteSlug}/select-slot`);
            }
        },
        setCurrentNavbarHeight() {
            const els = window.document.getElementsByClassName('floating');

            this.navbarHeight = 10;

            if (!els.length) {
                return;
            }

            for (const el of els) {
                this.navbarHeight += el.clientHeight;
            }
        },
        onMounted() {
            this.setCurrentNavbarHeight();
        }
    },
    mounted() {
        this.onMounted();

        if (!this.cart && this.siteSlug) {
            this.$axios
                .get(`/menus?site_slug=${this.siteSlug}`)
                .then(response => {
                    window.location = window.location;
                });
        }

        if (this.cart && !this.user && !localStorage.getItem('shownLogin')) {
            localStorage.setItem('shownLogin', true);

            this.$modal.show('login-modal');
        }
    }
}
</script>
